export default {
  dob: 'dob',
  currentDate: 'currentDate',
  stopTreatment: 'stopTreatment',
};
